import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'titlecasesplit' })
export class TitleCaseSplitPipe extends TitleCasePipe {

  transform(input: string | null | undefined): any {
    return super.transform(input.replace(/([A-Z])/g, ' $1').replace(/\.\w+/, '').trim());
  }
}
